import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import RobitoLogo from "../components/AppLogo";
import { apiPostPublic, apiPostAuth } from "../utils/api";
import "../App.css";

const RegisterPage = () => {
  const [searchParams] = useSearchParams();
  const referralFromUrl = searchParams.get("ref") || ""; // Get referral code from URL

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    company: "",
    referralCode: referralFromUrl, // Prefill with URL referral code if available
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const response = await apiPostAuth("account/is_logged_in.php");
        if (response.status === "success") {
          window.location.href = "/dashboard";
        }
      } catch (error) {
        
      }
    };

    checkLogin();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });

    // Clear error for the changed field
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    const referralRegex = /^[a-zA-Z0-9]*$/;

    if (!form.name.trim()) newErrors.name = "Nama wajib diisi.";
    if (!form.email.trim()) newErrors.email = "Email wajib diisi.";
    if (!form.password) {
      newErrors.password = "Password wajib diisi.";
    } else if (!passwordRegex.test(form.password)) {
      newErrors.password =
        "Password harus minimal 8 karakter, termasuk huruf besar, huruf kecil, dan angka.";
    }

    if (!form.confirmPassword) {
      newErrors.confirmPassword = "Confirm your password.";
    } else if (form.password !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    if (!form.company.trim()) newErrors.company = "Nama Merek/Usaha wajib diisi.";
    if (!form.agree)
      newErrors.agree =
        "Kamu harus menyetujui Kebijakan Layanan dan Kebijakan Privasi untuk mendaftar.";

    if (form.referralCode && !referralRegex.test(form.referralCode)) {
      newErrors.referralCode = "Kode referral tidak valid.";
    }

    return newErrors;
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      // Make API call to register.php
      const response = await apiPostPublic("register.php", {
        full_name: form.name,
        email: form.email,
        password: form.password,
        company_name: form.company,
        referral_code: form.referralCode || "", // Send empty string if no referral code
      });

      if (response.result === 1) {
        alert("Berhasil membuat akun!");
        window.location.href = "/dashboard";
      } else {
        alert(response.message || "Pendaftaran gagal, mohon coba lagi.");
      }
    } catch (error) {
      alert("Terjadi kesalahan saat mendaftar.");
      
    } finally {
      setLoading(false);
    }
  };

  const isFormIncomplete = () => {
    return (
      !form.name.trim() ||
      !form.email.trim() ||
      !form.password ||
      !form.confirmPassword ||
      form.password !== form.confirmPassword ||
      !form.company.trim() ||
      !form.agree
    );
  };

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Buat Akun</h2>
        <form onSubmit={handleRegister} className="form-container">
          {/* Full Name */}
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Nama Kamu"
              className="input-field"
              value={form.name}
              onChange={handleChange}
            />
            {errors.name && <span className="error-label">{errors.name}</span>}
          </div>

          {/* Email */}
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="input-field"
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && <span className="error-label">{errors.email}</span>}
          </div>

          {/* Password */}
          <div className="form-group password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              className="input-field"
              value={form.password}
              onChange={handleChange}
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Sembunyikan" : "Tampilkan"}
            </button>
            {errors.password && (
              <span className="error-label">{errors.password}</span>
            )}
          </div>

          {/* Confirm Password */}
          <div className="form-group">
            <input
              type={showPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Konfirmasi Password"
              className="input-field"
              value={form.confirmPassword}
              onChange={handleChange}
            />
            {errors.confirmPassword && (
              <span className="error-label">{errors.confirmPassword}</span>
            )}
          </div>

          {/* Company Name */}
          <div className="form-group">
            <input
              type="text"
              name="company"
              placeholder="Nama Merek/Usaha"
              className="input-field"
              value={form.company}
              onChange={handleChange}
            />
            {errors.company && (
              <span className="error-label">{errors.company}</span>
            )}
          </div>

          {/* Referral Code (Optional) */}
          <div className="form-group">
            <input
              type="text"
              name="referralCode"
              placeholder="Kode Referral (Opsional)"
              className="input-field"
              value={form.referralCode}
              onChange={handleChange}
              readOnly={!!searchParams.get("ref")} // Optional: lock if from URL
            />
            {errors.referralCode && <span className="error-label">{errors.referralCode}</span>}
          </div>

          {/* Terms and Conditions */}
          <label className="checkbox-container">
            <input
              type="checkbox"
              name="agree"
              checked={form.agree}
              onChange={handleChange}
            />
            <span>
              Dengan membuat akun, anda telah menyetujui{" "}
              <Link to="/terms" className="link">
                Kebijakan Layanan
              </Link>{" "}
              dan{" "}
              <Link to="/privacy" className="link">
                Kebijakan Privasi
              </Link>{" "}kami.
            </span>
          </label>
          {errors.agree && <span className="error-label">{errors.agree}</span>}

          {/* Register Button */}
          <button
            type="submit"
            className="primary-button"
            style={{ opacity: isFormIncomplete() ? 0.6 : 1 }}
            disabled={loading}
          >
            {loading ? "Mendaftar..." : "Daftar"}
          </button>
        </form>

        <p className="form-footer">
          Sudah punya akun?{" "}
          <Link to="/" className="link">
            Masuk
          </Link>
        </p>
        <div className="copyright">© MySite.co.id 2025</div>
      </div>
    </div>
  );
};

export default RegisterPage;
